import React from 'react';
import PropTypes from 'prop-types';
import { V2ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Brandmark } from '@uhg-abyss/web/ui/Brandmark';
import { V2Button } from '@uhg-abyss/web/ui/Button';
import { styled } from '@uhg-abyss/web/tools/styled';
import { config } from '@uhg-abyss/web/tools/config';

export const TermsOfUseModel = ({ isOpen, closeModal }) => {
  const handleCloseModal = () => {
    closeModal();
  };
  const HeaderLogo = styled('div', {
    height: 41,
    width: 131,
    marginLeft: 22,
  });
  const BlockMessageBody = styled('div', {
    marginTop: 12,
    marginBottom: 12,
    marginLeft: 18,
  });
  const BlockMessageTitle = styled('div', {
    marginTop: 23,
    marginLeft: 18,
    fontSize: '23px',
    marginBottom: 12,
    fontWeight: 600,
    fontFamily: '$heading',
    color: '$primary1',
  });
  const BlockMessageHeading = styled('div', {
    marginLeft: 18,
    fontSize: '18px',
    marginBottom: 16,
  });
  const VerticalSpacingBold = styled('div', {
    marginTop: 23,
    marginLeft: 22,
    fontSize: '26px',
    fontWeight: 600,
    fontFamily: '$heading',
    color: '$primary1',
  });

  return (
    <V2ModalDialog
      id="terms-of-use-modal"
      isOpen={isOpen}
      hideClose
      closeOnClickOutside={false}
      header={
        <React.Fragment>
          <HeaderLogo>
            <Brandmark
              affiliate="uhc"
              variant="lockup"
              color="blue"
              brand="uhc"
            />
          </HeaderLogo>
          <VerticalSpacingBold>Terms Of Use</VerticalSpacingBold>
        </React.Fragment>
      }
    >
      <div>Welcome! Thanks for using our site and applications.</div>
      <div>
        Please take a few minutes to read our Terms of Use. Upon completion,
        click the Accept button. You will then be routed to our site.
      </div>
      <Card>
        <Box color="$white">
          <BlockMessageTitle>
            IMPORTANT NOTE REGARDING WEBSITE CONTENT
          </BlockMessageTitle>
          <BlockMessageHeading>
            THIS DOCUMENT CONTAINS AN{' '}
            <a
              href={config('TERMS_OF_USE_PDF_URL')}
              data-testid="terms-of-use-pdf-url"
              target="_blank"
              rel="noopener noreferrer"
            >
              ARBITRATION AGREEMENT AND CLASS ACTION WAIVER
            </a>
            WHICH AFFECT YOUR LEGAL RIGHTS. YOU SHOULD REVIEW THIS DOCUMENTIN
            ITS ENTIRELY BEFORE ACCESSING OR USING THE ONLINE SERVICES.
          </BlockMessageHeading>
          <BlockMessageBody>
            These Terms of Use ("Terms" or "Agreement") constitute a legally
            binding agreement between you, the person using our online and
            mobile websites, platforms,services, and applications, and us. Terms
            such as "we","our","us," and "Company" refer to UnitedHealthCare
            Services, Inc. and its affiliate entities, including UnitedHealth
            Networks Inc. These Terms describe the rules for using our online
            and mobile websites,platforms,services, and applications we own and
            operate and that contain a link to these Terms (collectively,
            "Online Services"). Any references to "you" or "your" in these Terms
            will mean the person using the Online Services.
          </BlockMessageBody>
        </Box>
      </Card>
      <Layout.Group alignLayout="right" css={{ marginTop: '24px' }}>
        <V2Button onClick={handleCloseModal}>Accept</V2Button>
      </Layout.Group>
    </V2ModalDialog>
  );
};

TermsOfUseModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};
